/**
 * Do not edit directly, this file was auto-generated.
 */

export default {
  dark: {
    neutral: {
      0: "#ffffff",
      50: "#eeeeee",
      100: "#b4b4b4",
      200: "#6e6e6e",
      300: "#606060",
      400: "#484848",
      500: "#3a3a3a",
      600: "#313131",
      700: "#2a2a2a",
      800: "#222222",
      900: "#191919",
      950: "#000000",
    },
    neutralAlpha: {
      0: "#ffffffeb",
      50: "#ffffffd1",
      100: "#ffffff72",
      200: "#ffffff64",
      300: "#ffffff55",
      400: "#ffffff3b",
      500: "#ffffff2c",
      600: "#ffffff22",
      700: "#ffffff1b",
      800: "#ffffff12",
      900: "#ffffff09",
      950: "#00000000",
    },
    purple: {
      0: "#e4daff",
      50: "#bda3ff",
      100: "#6700d5",
      200: "#7500e9",
      300: "#7344cd",
      400: "#5c36a5",
      500: "#4c298d",
      600: "#411d7c",
      700: "#36136c",
      800: "#27134d",
      900: "#130c24",
      950: "#000000",
    },
    purpleAlpha: {
      0: "#e4daff",
      50: "#e4daff",
      100: "#bda3ff",
      200: "#7b00ffd5",
      300: "#8000ffe9",
      400: "#8f55ffcd",
      500: "#8e54ffa5",
      600: "#8a4bff8d",
      700: "#863cff7c",
      800: "#802dff6c",
      900: "#823fff4d",
      950: "#8755ff24",
    },
    orange: {
      0: "#fbd3cb",
      50: "#ff977d",
      100: "#ec6142",
      200: "#e54d2e",
      300: "#ac4d39",
      400: "#853a2d",
      500: "#6e2920",
      600: "#5e1c16",
      700: "#4e1511",
      800: "#391714",
      900: "#1f1513",
      950: "#181111",
    },
    orangeAlpha: {
      0: "#ffd6cefb",
      50: "#ff977d",
      100: "#ff6847eb",
      200: "#fe5431e4",
      300: "#fe6d4ea7",
      400: "#fd644a7d",
      500: "#ff4f3864",
      600: "#fe332153",
      700: "#fd201142",
      800: "#ff35232b",
      900: "#ff55330f",
      950: "#f1121208",
    },
    success: {
      0: "#b1f1cb",
      50: "#3dd68c",
      100: "#33b074",
      200: "#30a46c",
      300: "#2f7c57",
      400: "#28684a",
      500: "#20573e",
      600: "#174933",
      700: "#113b29",
      800: "#132d21",
      900: "#121b17",
      950: "#0e1512",
    },
    successAlpha: {
      0: "#bbffd7f0",
      50: "#46fea5d4",
      100: "#43fea4ab",
      200: "#44ffa49e",
      300: "#54ffad73",
      400: "#50fdac5e",
      500: "#44ffaa4b",
      600: "#2bffa23c",
      700: "#11ff992d",
      800: "#22ff991e",
      900: "#29f99d0b",
      950: "#00de4505",
    },
    error: {
      0: "#ffd1d9",
      50: "#ff9592",
      100: "#ec5d5e",
      200: "#e5484d",
      300: "#b54548",
      400: "#8c333a",
      500: "#72232d",
      600: "#611623",
      700: "#500f1c",
      800: "#3b1219",
      900: "#201314",
      950: "#191111",
    },
    errorAlpha: {
      0: "#ffd1d9",
      50: "#ff9592",
      100: "#ff6465eb",
      200: "#fe4e54e4",
      300: "#ff5d61b0",
      400: "#ff536184",
      500: "#ff3e5668",
      600: "#ff204756",
      700: "#fe0a3b44",
      800: "#ff173f2d",
      900: "#f22f3e11",
      950: "#f4121209",
    },
  },
  light: {
    neutral: {
      0: "#000000",
      50: "#202020",
      100: "#646464",
      200: "#838383",
      300: "#8d8d8d",
      400: "#bbbbbb",
      500: "#cecece",
      600: "#d9d9d9",
      700: "#e8e8e8",
      800: "#f0f0f0",
      900: "#f9f9f9",
      950: "#ffffff",
    },
    neutralAlpha: {
      0: "#000000df",
      50: "#0000009b",
      100: "#0000007c",
      200: "#00000072",
      300: "#00000044",
      400: "#00000031",
      500: "#00000026",
      600: "#0000001f",
      700: "#00000017",
      800: "#0000000f",
      900: "#00000006",
      950: "#00000003",
    },
    purple: {
      0: "#391173",
      50: "#752be0",
      100: "#6700d5",
      200: "#7500e9",
      300: "#b08cff",
      400: "#c5aeff",
      500: "#d6c6ff",
      600: "#e2d6ff",
      700: "#ebe2ff",
      800: "#f3efff",
      900: "#faf8ff",
      950: "#fcfcff",
    },
    purpleAlpha: {
      0: "#2b0069ed",
      50: "#2b0069ed",
      100: "#6700d5",
      200: "#7500e9",
      300: "#5000ff73",
      400: "#4900ff51",
      500: "#4800ff39",
      600: "#4b00ff29",
      700: "#5000ff1d",
      800: "#4000ff10",
      900: "#4900ff07",
      950: "#0000ff03",
    },
    orange: {
      0: "#5c271f",
      50: "#d13415",
      100: "#dd4425",
      200: "#e54d2e",
      300: "#ec8e7b",
      400: "#f5a898",
      500: "#fdbdaf",
      600: "#ffcdc2",
      700: "#ffdcd3",
      800: "#feebe7",
      900: "#fff8f7",
      950: "#fffcfc",
    },
    orangeAlpha: {
      0: "#460900e0",
      50: "#cd2200ea",
      100: "#d72400da",
      200: "#df2600d1",
      300: "#db250084",
      400: "#e7280067",
      500: "#f92d0050",
      600: "#ff2e003d",
      700: "#ff35002c",
      800: "#f52b0018",
      900: "#ff200008",
      950: "#ff000003",
    },
    success: {
      0: "#193b2d",
      50: "#218358",
      100: "#2b9a66",
      200: "#30a46c",
      300: "#5bb98b",
      400: "#8eceaa",
      500: "#adddc0",
      600: "#c4e8d1",
      700: "#d6f1df",
      800: "#e6f6eb",
      900: "#f4fbf6",
      950: "#fbfefc",
    },
    successAlpha: {
      0: "#002616e6",
      50: "#00713fde",
      100: "#008647d4",
      200: "#008f4acf",
      300: "#00924ba4",
      400: "#00914071",
      500: "#00963c52",
      600: "#019c393b",
      700: "#00a83829",
      800: "#00a43319",
      900: "#00a32f0b",
      950: "#00c04004",
    },
    error: {
      0: "#641723",
      50: "#ce2c31",
      100: "#dc3e42",
      200: "#e5484d",
      300: "#eb8e90",
      400: "#f4a9aa",
      500: "#fdbdbe",
      600: "#ffcdce",
      700: "#ffdbdc",
      800: "#feebec",
      900: "#fff7f7",
      950: "#fffcfc",
    },
    errorAlpha: {
      0: "#55000de8",
      50: "#c40006d3",
      100: "#d10005c1",
      200: "#db0007b7",
      300: "#d2000571",
      400: "#df000356",
      500: "#f8000442",
      600: "#ff000632",
      700: "#ff000824",
      800: "#f3000d14",
      900: "#ff000008",
      950: "#ff000003",
    },
  },
};
